document.querySelectorAll('[data-slider-id="slideshow"]').forEach(function (swiper) {
  const autoplay = swiper.getAttribute('data-autoplay');
  const speed = swiper.getAttribute('data-speed');

  const slideshowSwiper = new Swiper(swiper, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: autoplay === 'true' ? {
      delay: speed * 1000,
      disableOnInteraction: false,
    } : false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});
